var GrayMultiTabNavContainer = (function () {
  
  
  var Utility = window.Utility || {};
  
  var $multiTabNavContainer = $('section.rzf-gry.rzf-gry-multi-tab-nav-container');

  var $multiTabNavContainerTabs = $('.rzf-gry-multi-tab-container', $multiTabNavContainer);
  
  Utility.log('GrayMultiTabNavContainer js loaded');
  
  function init() {
    mutationObserver();
    prepDropDownNav();
  }
  
  function mutationObserver() {
    // create an observer instance
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var el = mutation.target;
        if ((mutation.type === 'attributes') && (mutation.attributeName === 'class')) {
          if ($(el).hasClass('active')) {
            // $(el).children(':first').trigger('tab:active');
            tabActiveCases(mutation);        
          } else {
            // $(el).children(':first').trigger('tab:not-active');  
          }
        }
      });    
    });
     
    // configuration of the observer:
    var config = { attributes: true, childList: true, characterData: true };
    
    $multiTabNavContainerTabs.each(function (i, el) {
      observer.observe(el, config);
    });
  }
  
  function prepDropDownNav() {
    $('div.dropdown ul li a', $multiTabNavContainer).each(function (i, el) {
      $(el).html('•');
    });
  }
  
  function tabActiveCases(mutationObj) {
    var activeElem = mutationObj.target;
    // If we have an active features panel as the child, pagination dots should be repositioned.
    if ($(activeElem).find('.rzf-gry-all-features-panel.active').length > 0) {
      // Get drop down nav (pagination dots in Acura Skin), should be positioned bottom.
      $('div.dropdown', $(activeElem).parent()).addClass('all-features');
    } else {
      $('div.dropdown', $(activeElem).parent()).removeClass('all-features');
    }
  }
  
  return {
    init: init,
  };
  
}());
